import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';
import type IconNames from '@hapvida/hapvida-core-components/src/assets/icons/IconNames';

import { BeneficiaryMovementTypeEnum } from '@constants';

export const MovementTypeValues: Record<
  BeneficiaryMovementTypeEnum,
  {
    icon: IconNames;
    value: string;
    color: string;
  }
> = {
  HolderInclusion: {
    icon: 'actions-b2b-add-user',
    value: 'Inclusão de titular',
    color: NEW_COLORS.SEMANTICS.SUCCESS[800],
  },
  DependentInclusion: {
    icon: 'medical-b2b-add-group',
    value: 'Inclusão de dependente',
    color: NEW_COLORS.SEMANTICS.SUCCESS[800],
  },
  Exclusion: {
    icon: 'actions-b2b-delete',
    value: 'Exclusão',
    color: NEW_COLORS.SEMANTICS.ERROR[600],
  },
  CadastralChange: {
    icon: 'actions-b2b-edit',
    value: 'Alteração',
    color: NEW_COLORS.PRIMARY[600],
  },
  ContractTransfer: {
    icon: 'actions-b2b-transfer-file',
    value: 'Transferência',
    color: NEW_COLORS.SECONDARY[600],
  },
  PlanChange: {
    icon: 'actions-b2b-swap-horizontal',
    value: 'Troca de plano',
    color: NEW_COLORS.SECONDARY[500],
  },
  Reactivation: {
    icon: 'actions-b2b-refresh',
    value: 'Reativação',
    color: NEW_COLORS.SECONDARY[500],
  },
  ExclusionCancelation: {
    icon: 'actions-b2b-delete-off',
    value: 'Cancelar Exclusão',
    color: NEW_COLORS.SECONDARY[600],
  },
  Retired: {
    icon: 'medical-b2b-add-group',
    value: 'Aposentado e/ou demitido',
    color: NEW_COLORS.GRAYSCALE[700],
  },
};
